import api from "../apis/api";

class JoinMeetingService {
    joinMeetingServiceFunction(req) {
        return api.joinMeetingFunction.joinMeeting(req);
    }

    sendDeviceInformationService(req) {
        return api.joinMeetingFunction.sendDeviceInformationApi(req);
    }
}
export default new JoinMeetingService();
